import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeScalableIcon } from '@mend/mui';
import { Button } from '@mui/material';

export function SeeMore(props: { flag: boolean; additional: number; toggle: () => void }) {
  return (
    <Button
      variant="text"
      color="info"
      size="small"
      onClick={props.toggle}
      endIcon={<FontAwesomeScalableIcon icon={props.flag ? faChevronUp : faChevronDown} />}
    >
      {props.flag ? 'See less' : `+${props.additional} more`}
    </Button>
  );
}
